<template lang="pug">
  div(v-cloak).sub-page
    CommonHeader
    main
      v-container
        h1 DLG国際品質競技会
        v-layout.white_container.pa-5.justify-center(row wrap)
          v-container
            v-layout.justify-center.px-5(row wrap)
              h2 BÜRGER社は
                br
                | ＤＬＧ国際品質競技会で金賞を受賞しています。
              img(src='/static/images/dlg_medal.png', alt='DLG国際品質競技会メダル')
              v-flex(xs12)
                p.text-xs-center.my-3 ＤＬＧ国際品質競技会とは、ＤＬＧ（ドイツ農業振興協会）により1887年より開催されている
                  br
                  | 歴史と権威のある世界最大規模の食品品質競技会です。
              span(style='font-size: .8rem')
                | DLG公式サイト
                a(href='http://www.dlg.org/') http://www.dlg.org/
              v-flex(xs12 v-for='(item, index) in texts' :key='item.title')
                h3.mt-5 {{ item.title }}
                p {{ item.text }}
              v-flex(xs12).award.mt-5
                h3.mt-5 ビュルガー社受賞商品(2014年)
                h4 金賞
                ul
                  li(v-for='(item, index) in list' :key='item.name') {{ item.name }}
                h4.mt-3 銅賞
                ul(style='margin-bottom: 200px')
                  li Bio-Schupfnudeln
    CommonFooter

</template>

<script>
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted: function () {
  },
  data () {
    return {
      texts: [
        {
          'title': 'DLGとは',
          'text': 'DLG（Deutsche Landwirtschafts-Gesellschaft）ドイツ農業振興協会は、ドイツのフランクフルトに本部を置く農業協会であり、1885年に設立されました。1887年より加工食品の品質競技会を開催し、1993年よりは国際大会となり、現在では世界最大規模の食品品質競技会となっています。審査対象は食肉製品、乳製品、ビール、チーズ、冷凍食品、など多岐にわたり、日本を含め世界各国から約5,000品目が出品されています。欧州ではこの厳格な審査基準のもと受賞した商品への信頼度は極めて高く、金賞の受賞は欧州のみならず世界各国の多くの食品メーカーの目標となっており、金賞の受賞を目指し日々商品開発や改善が行われています。'
        }, {
          'title': '200近い厳密な審査項目',
          'text': 'DLG食品競技会では、味、色、香り、風味、食感から添加物の種類や量、パッケージに至るまで、200近い項目によって審査され、その結果により金賞、銀賞、銅賞、賞状が授与されます。 採点は減点方式で行われ、減点なく全項目満点をの商品だけが金賞を受賞した商品だけが金賞を受賞することができます。'
        }
      ],
      list: [
        {
          'name': 'Schwäbische Kartoffel-Schupfnudeln'
        }, {
          'name': 'Schwäbische Eierspätzle'
        }, {
          'name': 'Schwäbische Eierknöpfle'
        }, {
          'name': 'Unsere Besten Maultaschen'
        }, {
          'name': 'Unsere Besten Maultaschen vegetarisch'
        }, {
          'name': 'Maultaschen gerollt'
        }, {
          'name': 'Maultaschen original schwäbisch 300g'
        }, {
          'name': 'Unsere Besten Kalbfleischtaschen'
        }, {
          'name': 'Maultaschen traditionell schwäbisch 360g'
        }
      ]
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="stylus">
// breakpoint
screen-xs = 600px
screen-sm = 960px
breakpoint(bpName)
    for name in bpName
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}

// color
$color-primary = #502e28
$color-secondary = #ecddbc
$color-gold = #a5801f

.white_container
  background-image url(../../../../../static/images/dlg_bg_top.jpg)
  background-repeat no-repeat
  background-size contain
  border 3px solid $color-gold
  border-radius 0
  position relative
  &::after
    content ''
    position absolute
    top 0
    width 100%
    height 100%
    border 5px solid white
  &::before
    content ''
    background-image url(../../../../../static/images/dlg_bg_bottom.jpg)
    background-repeat no-repeat
    background-size contain
    background-position bottom
    position absolute
    top 0
    width 100%
    height 100%
    border 6px solid $color-gold
  .award
    border-top 1px solid $color-gold
    h3,h4
      color $color-gold
    li
      font-size .8rem
      text-align center
</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Dlg/index.vue